import { api } from '../api';
import { requireFeatureOrRedirect } from '../auth';
import { confirmDialog, escapeHtml, toast } from '../utils';

export async function initFriends() {
  // Друзі/рекомендації недоступні гостьовому акаунту (право 'social'): його перекидає в Каталог.
  if (!(await requireFeatureOrRedirect('social'))) return;

  const input = document.getElementById('friend-add-input') as HTMLInputElement;
  const addBtn = document.getElementById('friend-add-btn') as HTMLButtonElement;
  const errorEl = document.getElementById('friend-add-error') as HTMLElement;
  const listEl = document.getElementById('friends-list') as HTMLElement;
  const emptyEl = document.getElementById('friends-empty') as HTMLElement;

  function renderList(friends: string[]) {
    listEl.innerHTML = '';
    emptyEl.style.display = friends.length ? 'none' : 'flex';
    for (const username of friends.slice().sort((a, b) => a.localeCompare(b, 'uk'))) {
      const row = document.createElement('div');
      row.className = 'row friend-row';
      row.innerHTML = `
        <div class="friend-avatar">${escapeHtml(username.slice(0, 2).toUpperCase())}</div>
        <div class="meta"><p class="title">${escapeHtml(username)}</p></div>
        <button type="button" class="iconbtn trailing-icon friend-remove-btn" aria-label="Видалити з друзів" title="Видалити з друзів">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
        </button>`;
      const removeBtn = row.querySelector('.friend-remove-btn') as HTMLButtonElement;
      removeBtn.addEventListener('click', async () => {
        const ok = await confirmDialog({
          title: 'Видалити з друзів?',
          message: `${username} більше не зможе рекомендувати вам твори, а ви — йому.`,
          confirmText: 'Видалити',
          danger: true,
        });
        if (!ok) return;
        try {
          const res = await api.removeFriend(username);
          toast('Видалено з друзів');
          renderList(res.friends);
        } catch (err) {
          toast((err as Error).message);
        }
      });
      listEl.appendChild(row);
    }
  }

  async function refresh() {
    try {
      const res = await api.friends();
      renderList(res.friends);
    } catch (err) {
      toast((err as Error).message);
    }
  }

  async function submitAdd() {
    const username = input.value.trim();
    errorEl.style.display = 'none';
    if (!username) return;
    addBtn.disabled = true;
    try {
      const res = await api.addFriend(username);
      input.value = '';
      toast(`${username} додано в друзі`);
      renderList(res.friends);
    } catch (err) {
      errorEl.textContent = (err as Error).message;
      errorEl.style.display = 'block';
    } finally {
      addBtn.disabled = false;
    }
  }

  addBtn.addEventListener('click', submitAdd);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') submitAdd();
  });

  refresh();
}
